<template>
    <div class="content-wrapper">
        <div class="content-header row">
            <div class="content-header-left col-md-9 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Plaka İşlem Geçmişi</h2>
                        <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><router-link to="/">Anasayfa</router-link></li>
                                <li class="breadcrumb-item"><a href="#">Envanter İşlemleri</a></li>
                                <li class="breadcrumb-item active">Plaka İşlem Geçmişi</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-body">
            <b-card no-body>
                <v-table :fields="fields" :items-provider="dataProvider" pagination="server" search :initial-per-page="10">
                    <template #empty>
                        <div class="text-center p-3">
                            <span class="text-muted">Kayıtlı işlem geçmişi bulunamadı.</span>
                        </div>
                    </template>
                </v-table>
            </b-card>
        </div>
    </div>
</template>

<script>
import { BCard } from "bootstrap-vue";
import VehicleOperationsApi from "@/api/vehicle-operations";

export default {
    components: {
        BCard,
    },
    data() {
        return {
            fields: [
                { key: "DateValue", name: "İşlem Tarihi", tdClass: "w-15 text-nowrap" },
                { key: "VehicleInventoryNo", name: "Envanter No", tdClass: "w-20 text-nowrap" },
                { key: "VehicleBrand", name: "Marka", tdClass: "w-15 text-nowrap" },
                { key: "VehicleModel", name: "Model", tdClass: "w-10 text-nowrap" },
                { key: "VehicleSerialNo", name: "Seri", tdClass: "w-10 text-nowrap" },
                { key: "OldPlateValue", name: "Eski Plaka", tdClass: "text-danger font-weight-bold w-10 text-nowrap" },
                { key: "NewPlateValue", name: "Yeni Plaka", tdClass: "text-success font-weight-bold w-10 text-nowrap" },
                { key: "PlateRemoveReason", name: "Açıklama", tdClass: "text-success font-weight-bold w-10 text-nowrap" },
            ],
        };
    },
    methods: {
        dataProvider(params) {
            return VehicleOperationsApi.Plate.History(params);
        },
    },
};
</script>
